import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=2417d7b0&scoped=true&"
import script from "./channel.vue?vue&type=script&lang=ts&"
export * from "./channel.vue?vue&type=script&lang=ts&"
import style0 from "./channel.vue?vue&type=style&index=0&id=2417d7b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2417d7b0",
  null
  
)

export default component.exports